import type { Business } from "@/types/directory";

export const businessesPartD: Business[] = [
  {
    id: "biz-23",
    slug: "hegde-ayurvedic-centre",
    name: "Hegde Ayurvedic Centre",
    tagline: "Authentic Ayurvedic care and Panchakarma therapy",
    description:
      "A traditional Ayurvedic treatment centre in Karkala offering doctor-guided Panchakarma, Kizhi therapy, physiotherapy and rejuvenation packages using classical herbal formulations prepared in-house.",
    categorySlug: "healthcare",
    subcategory: "Ayurvedic Centres",
    districtSlug: "udupi",
    locationSlug: "karkala",
    address: "Gomateshwara Road, Karkala, Udupi District - 574104",
    phone: "+91 8258 232 640",
    whatsapp: "+91 99726 32640",
    email: "care@hegdeayurveda.in",
    website: "https://hegdeayurveda.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Karkala%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Calm%20traditional%20Ayurvedic%20wellness%20centre%20with%20wooden%20therapy%20rooms%2C%20brass%20oil%20lamps%20and%20herbal%20decor%2C%20serene%20natural%20lighting%2C%20wellness%20interior%20photography&width=1200&height=800&seq=cbc-biz-hegde-ayurveda-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Ayurvedic%20herbal%20oil%20massage%20therapy%20setup%20with%20fresh%20herbs%20and%20warm%20lighting%2C%20wellness%20therapy%20photography&width=1200&height=800&seq=cbc-biz-hegde-ayurveda-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Jars%20of%20traditional%20Ayurvedic%20herbal%20powders%20and%20oils%20neatly%20arranged%20on%20a%20wooden%20shelf%2C%20warm%20lighting%2C%20wellness%20product%20photography&width=1200&height=800&seq=cbc-biz-hegde-ayurveda-g2-01&orientation=landscape",
    ],
    rating: 4.8,
    reviewCount: 176,
    verified: true,
    sponsored: false,
    featured: true,
    plan: "Premium",
    openNow: true,
    yearsInBusiness: 21,
    hours: [
      { day: "Monday", open: "08:00", close: "19:00", closed: false },
      { day: "Tuesday", open: "08:00", close: "19:00", closed: false },
      { day: "Wednesday", open: "08:00", close: "19:00", closed: false },
      { day: "Thursday", open: "08:00", close: "19:00", closed: false },
      { day: "Friday", open: "08:00", close: "19:00", closed: false },
      { day: "Saturday", open: "08:00", close: "18:00", closed: false },
      { day: "Sunday", open: "09:00", close: "13:00", closed: false },
    ],
    services: ["Panchakarma", "Kizhi Therapy", "Physiotherapy", "Rejuvenation Packages"],
    tags: ["Classical Ayurveda", "In-House Medicines", "Doctor Guided", "Wellness"],
    reviews: [
      {
        id: "rev-23-1",
        author: "Manjunath S.",
        rating: 5,
        date: "2026-08-12",
        comment: "The Panchakarma package genuinely helped my back pain. Skilled therapists and calm ambience.",
        verified: true,
      },
      {
        id: "rev-23-2",
        author: "Lavanya R.",
        rating: 5,
        date: "2026-07-05",
        comment: "Authentic treatment and very caring doctors. The herbal oils are made in-house.",
        verified: true,
      },
    ],
  },
  {
    id: "biz-24",
    slug: "indraprastha-family-restaurant",
    name: "Indraprastha Family Restaurant",
    tagline: "Multi-cuisine dining on the Kundapura highway",
    description:
      "A popular family restaurant in Kundapura serving North Indian, Chinese and coastal favourites, with a spacious air-conditioned hall, quick service and ample parking for travellers on the coastal highway.",
    categorySlug: "restaurants",
    subcategory: "Family Restaurants",
    districtSlug: "udupi",
    locationSlug: "kundapura",
    address: "NH-66, Kundapura, Udupi District - 576201",
    phone: "+91 8254 232 110",
    whatsapp: "+91 97314 32110",
    email: "info@indraprastharestaurant.in",
    website: "https://indraprastharestaurant.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Kundapura%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Spacious%20modern%20multi-cuisine%20family%20restaurant%20interior%20with%20warm%20lighting%2C%20comfortable%20seating%20and%20inviting%20decor%2C%20hospitality%20interior%20photography&width=1200&height=800&seq=cbc-biz-indraprastha-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Appetizing%20North%20Indian%20thali%20with%20curries%2C%20naan%20and%20dessert%20served%20on%20a%20wooden%20table%2C%20warm%20food%20photography&width=1200&height=800&seq=cbc-biz-indraprastha-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Indo-Chinese%20dishes%20like%20noodles%20and%20manchurian%20plated%20neatly%20on%20a%20restaurant%20table%2C%20warm%20lighting%2C%20food%20photography&width=1200&height=800&seq=cbc-biz-indraprastha-g2-01&orientation=landscape",
    ],
    rating: 4.4,
    reviewCount: 264,
    verified: true,
    sponsored: false,
    featured: true,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 11,
    hours: [
      { day: "Monday", open: "11:00", close: "23:00", closed: false },
      { day: "Tuesday", open: "11:00", close: "23:00", closed: false },
      { day: "Wednesday", open: "11:00", close: "23:00", closed: false },
      { day: "Thursday", open: "11:00", close: "23:00", closed: false },
      { day: "Friday", open: "11:00", close: "23:30", closed: false },
      { day: "Saturday", open: "11:00", close: "23:30", closed: false },
      { day: "Sunday", open: "11:00", close: "23:00", closed: false },
    ],
    services: ["North Indian", "Chinese", "Coastal Specials", "Family Dining"],
    tags: ["Multi-Cuisine", "AC Hall", "Ample Parking", "Highway Stop"],
    reviews: [
      {
        id: "rev-24-1",
        author: "Vivek Shetty",
        rating: 5,
        date: "2026-08-09",
        comment: "Great highway stop with clean facilities and quick service. The coastal fish curry was superb.",
        verified: true,
      },
      {
        id: "rev-24-2",
        author: "Reshma N.",
        rating: 4,
        date: "2026-06-30",
        comment: "Good food and spacious seating for families. Slightly busy on weekends.",
        verified: true,
      },
    ],
  },
  {
    id: "biz-25",
    slug: "malpe-sea-foods",
    name: "Malpe Sea Foods",
    tagline: "Fresh catch, cooked the coastal way",
    description:
      "A beloved seafood kitchen near Malpe beach in Udupi serving freshly caught fish, prawn ghee roast, neer dosa and Mangalorean curries, with a lively open-air dining space overlooking the harbour.",
    categorySlug: "restaurants",
    subcategory: "Seafood Restaurants",
    districtSlug: "udupi",
    locationSlug: "udupi-city",
    address: "Malpe Beach Road, Udupi, Udupi District - 576108",
    phone: "+91 820 253 4455",
    whatsapp: "+91 98450 34455",
    email: "hello@malpeseafoods.in",
    website: "https://malpeseafoods.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Malpe%20Beach%20Udupi%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Rustic%20coastal%20seafood%20restaurant%20with%20open-air%20seating%20near%20a%20harbour%2C%20warm%20evening%20lighting%20and%20traditional%20decor%2C%20hospitality%20photography&width=1200&height=800&seq=cbc-biz-malpe-seafood-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Authentic%20Mangalorean%20seafood%20platter%20with%20prawn%20ghee%20roast%20and%20fried%20fish%20on%20a%20banana%20leaf%2C%20warm%20food%20photography&width=1200&height=800&seq=cbc-biz-malpe-seafood-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Fresh%20whole%20fish%20displayed%20on%20crushed%20ice%20at%20a%20coastal%20market%20stall%2C%20bright%20natural%20light%2C%20food%20photography&width=1200&height=800&seq=cbc-biz-malpe-seafood-g2-01&orientation=landscape",
    ],
    rating: 4.7,
    reviewCount: 356,
    verified: true,
    sponsored: false,
    featured: true,
    plan: "Premium",
    openNow: true,
    yearsInBusiness: 16,
    hours: [
      { day: "Monday", open: "11:30", close: "22:30", closed: false },
      { day: "Tuesday", open: "11:30", close: "22:30", closed: false },
      { day: "Wednesday", open: "11:30", close: "22:30", closed: false },
      { day: "Thursday", open: "11:30", close: "22:30", closed: false },
      { day: "Friday", open: "11:30", close: "23:00", closed: false },
      { day: "Saturday", open: "11:30", close: "23:00", closed: false },
      { day: "Sunday", open: "11:30", close: "22:30", closed: false },
    ],
    services: ["Fresh Seafood", "Mangalorean Curries", "Neer Dosa", "Open-Air Dining"],
    tags: ["Fresh Catch Daily", "Sea View", "Neer Dosa", "Coastal Special"],
    reviews: [
      {
        id: "rev-25-1",
        author: "Rohan Dias",
        rating: 5,
        date: "2026-08-14",
        comment: "The prawn ghee roast and neer dosa were outstanding. Fresh fish, unbeatable taste.",
        verified: true,
      },
      {
        id: "rev-25-2",
        author: "Shalini P.",
        rating: 5,
        date: "2026-07-21",
        comment: "Loved dining right by the harbour. Friendly staff and generous portions.",
        verified: true,
      },
    ],
  },
  {
    id: "biz-26",
    slug: "prasad-sweets-and-namkeen",
    name: "Prasad Sweets & Namkeen",
    tagline: "Traditional sweets and crispy namkeen, made fresh",
    description:
      "A long-standing sweet mart in Mangaluru preparing a wide range of Indian sweets, hot namkeen and festival specials every day, with packaged gift boxes and bulk orders for weddings and events.",
    categorySlug: "restaurants",
    subcategory: "Sweets & Namkeen",
    districtSlug: "south-canara",
    locationSlug: "mangaluru",
    address: "G.H.S. Road, Mangaluru, Dakshina Kannada - 575001",
    phone: "+91 824 244 5566",
    whatsapp: "+91 98867 45566",
    email: "orders@prasadsweets.in",
    website: "https://prasadsweets.in",
    mapEmbedUrl: "https://www.google.com/maps?q=GHS%20Road%20Mangaluru%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Traditional%20Indian%20sweet%20shop%20with%20glass%20counters%20full%20of%20colourful%20sweets%20and%20savoury%20namkeen%2C%20warm%20inviting%20retail%20lighting%2C%20food%20photography&width=1200&height=800&seq=cbc-biz-prasad-sweets-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Assorted%20Indian%20sweets%20like%20barfi%20and%20ladoo%20arranged%20on%20a%20silver%20tray%2C%20warm%20studio%20lighting%2C%20food%20product%20photography&width=1200&height=800&seq=cbc-biz-prasad-sweets-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Crispy%20golden%20Indian%20namkeen%20mixture%20displayed%20in%20a%20large%20bowl%20at%20a%20sweet%20shop%2C%20warm%20lighting%2C%20food%20photography&width=1200&height=800&seq=cbc-biz-prasad-sweets-g2-01&orientation=landscape",
    ],
    rating: 4.5,
    reviewCount: 297,
    verified: true,
    sponsored: false,
    featured: true,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 34,
    hours: [
      { day: "Monday", open: "08:30", close: "21:30", closed: false },
      { day: "Tuesday", open: "08:30", close: "21:30", closed: false },
      { day: "Wednesday", open: "08:30", close: "21:30", closed: false },
      { day: "Thursday", open: "08:30", close: "21:30", closed: false },
      { day: "Friday", open: "08:30", close: "22:00", closed: false },
      { day: "Saturday", open: "08:30", close: "22:00", closed: false },
      { day: "Sunday", open: "08:30", close: "21:30", closed: false },
    ],
    services: ["Indian Sweets", "Namkeen", "Gift Boxes", "Bulk & Wedding Orders"],
    tags: ["Fresh Daily", "Since 1992", "Festival Specials", "Bulk Orders"],
    reviews: [
      {
        id: "rev-26-1",
        author: "Ganesh Rao",
        rating: 5,
        date: "2026-08-06",
        comment: "Their Mysore pak and mixture are unbeatable. Ordered sweets for a family function and everyone loved them.",
        verified: true,
      },
      {
        id: "rev-26-2",
        author: "Anjali M.",
        rating: 4,
        date: "2026-06-28",
        comment: "Consistent quality for years. Gift boxes are neatly packed.",
        verified: true,
      },
    ],
  },
  {
    id: "biz-27",
    slug: "ratnakar-builders",
    name: "Ratnakar Builders",
    tagline: "Quality homes and turnkey construction since 1999",
    description:
      "A trusted builder and developer in Mangaluru delivering residential apartments, independent villas and turnkey commercial projects, with transparent pricing, in-house engineering and on-time handover.",
    categorySlug: "real-estate",
    subcategory: "Builders & Developers",
    districtSlug: "south-canara",
    locationSlug: "mangaluru",
    address: "Kavoor Road, Mangaluru, Dakshina Kannada - 575003",
    phone: "+91 824 245 3300",
    whatsapp: "+91 99025 53300",
    email: "projects@ratnakarbuilders.in",
    website: "https://ratnakarbuilders.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Kavoor%20Mangaluru%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20residential%20apartment%20project%20under%20construction%20with%20architectural%20render%20board%20and%20sales%20office%2C%20bright%20daylight%2C%20real%20estate%20development%20photography&width=1200&height=800&seq=cbc-biz-ratnakar-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Newly%20completed%20modern%20apartment%20building%20with%20balconies%20and%20landscaped%20entrance%2C%20clear%20sky%2C%20architectural%20photography&width=1200&height=800&seq=cbc-biz-ratnakar-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Bright%20modern%20villa%20living%20room%20with%20contemporary%20furniture%20and%20large%20windows%2C%20interior%20real%20estate%20photography&width=1200&height=800&seq=cbc-biz-ratnakar-g2-01&orientation=landscape",
    ],
    rating: 4.5,
    reviewCount: 164,
    verified: true,
    sponsored: false,
    featured: true,
    plan: "Business",
    openNow: true,
    yearsInBusiness: 27,
    hours: [
      { day: "Monday", open: "09:30", close: "18:30", closed: false },
      { day: "Tuesday", open: "09:30", close: "18:30", closed: false },
      { day: "Wednesday", open: "09:30", close: "18:30", closed: false },
      { day: "Thursday", open: "09:30", close: "18:30", closed: false },
      { day: "Friday", open: "09:30", close: "18:30", closed: false },
      { day: "Saturday", open: "10:00", close: "17:00", closed: false },
      { day: "Sunday", open: "00:00", close: "00:00", closed: true },
    ],
    services: ["Apartments", "Villas", "Turnkey Construction", "Site Visits"],
    tags: ["RERA Registered", "On-Time Handover", "Turnkey Projects", "27 Years"],
    reviews: [
      {
        id: "rev-27-1",
        author: "Sunil Poojary",
        rating: 5,
        date: "2026-07-29",
        comment: "Handover was on schedule and the finish quality was excellent. Communication was clear throughout.",
        verified: true,
      },
      {
        id: "rev-27-2",
        author: "Ashwini K.",
        rating: 4,
        date: "2026-06-22",
        comment: "Reliable builder with fair pricing. Happy with our apartment.",
        verified: true,
      },
    ],
  },
  {
    id: "biz-28",
    slug: "tulunadu-motors",
    name: "Tulunadu Motors",
    tagline: "New cars, easy finance and reliable service",
    description:
      "An authorised car dealership and service centre in Ankola serving the North Canara coast, offering new and pre-owned cars, finance assistance, genuine spares and modern workshop servicing.",
    categorySlug: "automobile",
    subcategory: "Car Dealers",
    districtSlug: "north-canara",
    locationSlug: "ankola",
    address: "NH-66, Ankola, Uttara Kannada - 581314",
    phone: "+91 8388 231 700",
    whatsapp: "+91 96322 31700",
    email: "sales@tulunadumotors.in",
    website: "https://tulunadumotors.in",
    mapEmbedUrl: "https://www.google.com/maps?q=Ankola%20Karnataka&output=embed",
    logo: "",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20car%20showroom%20interior%20with%20polished%20floor%2C%20bright%20lighting%20and%20neatly%20arranged%20new%20cars%20on%20display%2C%20professional%20automotive%20retail%20photography&width=1200&height=800&seq=cbc-biz-tulunadu-motors-cover-01&orientation=landscape",
    gallery: [
      "https://readdy.ai/api/search-image?query=Clean%20modern%20car%20service%20workshop%20with%20a%20vehicle%20on%20a%20lift%20and%20organized%20tools%2C%20bright%20industrial%20lighting%2C%20automotive%20service%20photography&width=1200&height=800&seq=cbc-biz-tulunadu-motors-g1-01&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Neat%20row%20of%20polished%20new%20cars%20in%20a%20dealership%20lot%20with%20sales%20flags%2C%20bright%20daylight%2C%20automotive%20dealership%20photography&width=1200&height=800&seq=cbc-biz-tulunadu-motors-g2-01&orientation=landscape",
    ],
    rating: 4.3,
    reviewCount: 112,
    verified: true,
    sponsored: true,
    featured: false,
    plan: "Premium",
    openNow: true,
    yearsInBusiness: 12,
    hours: [
      { day: "Monday", open: "09:00", close: "19:00", closed: false },
      { day: "Tuesday", open: "09:00", close: "19:00", closed: false },
      { day: "Wednesday", open: "09:00", close: "19:00", closed: false },
      { day: "Thursday", open: "09:00", close: "19:00", closed: false },
      { day: "Friday", open: "09:00", close: "19:00", closed: false },
      { day: "Saturday", open: "09:00", close: "19:30", closed: false },
      { day: "Sunday", open: "10:00", close: "14:00", closed: false },
    ],
    services: ["New Cars", "Pre-Owned Cars", "Service & Repair", "Finance"],
    tags: ["Authorised Dealer", "Easy Finance", "Genuine Spares", "Test Drive"],
    reviews: [
      {
        id: "rev-28-1",
        author: "Naveen Naik",
        rating: 5,
        date: "2026-08-05",
        comment: "Smooth buying experience and they arranged finance quickly. Service team is prompt too.",
        verified: true,
      },
    ],
  },
];